export const SET_AUTHENTICATION_METHOD = 'SetAuthenticationMethod';
export const SET_CSRF = 'SetCSRF';
export const CHANGE_DISPLAY_LANGUAGE = 'CHANGE_DISPLAY_LANGUAGE';
export function setAuthentication({ accessToken, expiresAt, }) {
    return {
        type: SET_AUTHENTICATION_METHOD,
        payload: {
            accessToken,
            expiresAt,
        },
    };
}
export function setCSRF(csrf, sessionId) {
    return {
        type: SET_CSRF,
        payload: { csrf, sessionId },
    };
}
